export const CircleTickSolid = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#187802" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6336 6.0345C15.9016 6.30251 15.9016 6.73703 15.6336 7.00504L8.77088 13.8678C8.50288 14.1358 8.06835 14.1358 7.80035 13.8678L4.36897 10.4364C4.10097 10.1684 4.10097 9.73388 4.36897 9.46587C4.63698 9.19787 5.07151 9.19787 5.33951 9.46587L8.28562 12.412L14.6631 6.0345C14.9311 5.76649 15.3656 5.76649 15.6336 6.0345Z"
      fill="white"
    />
  </svg>
);
